import { fetchUpload, URL_UPLOAD_FILE, URL_UPLOAD_PHOTO, URL_UPLOAD_ALL } from "../config"
import { getToken } from "../component/Login/Auth";
import { toLogout, cleanFetch } from "./apiTools";


export const api_upload_file= ({ file, uploadPath=URL_UPLOAD_FILE, success, failure }) => {
    var token = getToken();
    if (token === "") {
        toLogout(false);
    } else {
        // console.log(file)
        // console.log(success)
        // console.log(failure)
        const fd = new FormData()
        fd.append('file', file)
        cleanFetch({
            body: fetchUpload({
                body: fd,
                token
            }),
            url: uploadPath,
            success: (jsonData) => {
                success(jsonData)
            },
            failure: (err) => {
                failure(err)
            }
        })
    }
}
